export default {
  EMPTY: "/",
  OPERATIONS_MANAGEMENT: "/operations-management",
  GRADE_MANAGEMENT: "/grade-management",
  OBSTACLE_INTELLIGENCE: "/obstacle-detection",
  JOBSITE_AUTOMATION: "/automation",
};
